import { combineReducers } from 'redux';

import list from './reducers/list';
import state from './reducers/state';

export default combineReducers({
  list,
  state,
});
